<div class="container">
    <div class="row g-3">
        <div class="col-xl-8 col-lg-8 col-md-6 col-12">
            <div class="d-flex">
                <h2 class="m-0">
                    ตั้งค่าบัตรกำนัล
                </h2>
                <button class="btn btn-primary ms-md-2 ms-auto" (click)="addGift()">เพิ่มบัตรกำนัล</button>
            </div>
        </div>
        <div class="col-xl-4 col-lg-4 col-md-6 col-12 text-md-end">
            <!-- <div class="input-icon-start">
                <input type="text" class="form-control" placeholder="ค้นหาบัตรกำนัล">
                <span class="material-symbols-outlined">
                    search
                </span>
            </div> -->
            <app-filter [text]="'ค้นหาบัตรกำนัล'" (updateValue)="getGift($event)"></app-filter>
        </div>
    </div>
    <br>
    <div class="row g-3">
        <div class="col-12">
            <table class="table align-middle" *ngIf="giftItems">
                <thead>
                    <tr>
                        <th colspan="2" class="d-none d-md-table-cell">บัตรกำนัล</th>
                        <th class="d-none  d-md-table-cell">ประเภท</th>
                        <th class="d-none  d-md-table-cell">วันที่หมดอายุ </th>
                        <th class="d-none  d-lg-table-cell"></th>
                        <th class="d-none  d-md-table-cell text-end">จัดการ</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let rw of giftItems">
                        <td [width]="48">
                            <img [src]="rw.Image" alt="">
                        </td>
                        <td><b>{{rw.Name}}</b>
                            <br>
                            <div class="detail d-block d-md-none">

                                <span>ประเภทบัตรกำนัล:
                                    <span *ngIf="rw.Type == 'discount'">ส่วนลด</span>
                                    <span *ngIf="rw.Type != 'discount'">สิ่งของ</span>
                                </span>
                                <br>
                                <span>วันที่หมดอายุ:
                                    {{rw.Expire_start | date:'dd/MM/yyyy'}} -
                                    {{rw.Expire_end | date:'dd/MM/yyyy'}}</span>
                            </div>
                        </td>
                        <td class="d-none d-md-table-cell"><span class="content-text">
                                <span *ngIf="rw.Type == 'discount'">ส่วนลด</span>
                                <span *ngIf="rw.Type != 'discount'">สิ่งของ</span>
                            </span>
                        </td>
                        <td class="d-none d-md-table-cell">
                            <span>{{rw.Expire_start | date:'dd/MM/yyyy'}} -
                                {{rw.Expire_end | date:'dd/MM/yyyy'}}</span>
                        </td>
                        <td [width]="300" class="d-none d-lg-table-cell">
                            <div class="d-flex">
                                <button class="btn btn-cancel w-100 me-3" (click)="sendGift(rw)">
                                    ส่งบัตรกำนัล
                                </button>
                            </div>
                        </td>
                        <td class="text-end">
                            <span class="material-icons pointer" (click)="viewMenu(rw,menu,$event)">
                                more_vert
                            </span>
                            <p-menu [model]="setitem" #menu [popup]="true"></p-menu>
                        </td>
                    </tr>
                </tbody>
            </table>
            <app-pagination *ngIf="giftItems" [page]="1" [pageTotal]="pageTotal"
                (updatePage)="getGift($event)"></app-pagination>
        </div>
    </div>
</div>


<p-dialog [header]="message" [(visible)]="manageGift" [modal]="true"
    [breakpoints]="{ '1199px': '75vw', '575px': '90vw' }" [style]="{ width: '50vw' }" [formGroup]="formGift"
    (onHide)="clearEvent()">
    <br><br>
    <ng-container *ngIf="manageGift">
        <div class="row g-3">
            <div class="col-12 mb-3 image text-center">
                <app-upload-file [action]="imageAction" (FileUpload)="uploadFile($event)">
                    <div class="box-image pointer" *ngIf="!viewImage && !formGift.value['Image']">
                        <br><br>
                        <div class="icon-box">
                            <span class="material-symbols-outlined">
                                upload
                            </span>
                        </div>
                        <br>
                        อัพโหลดรูปภาพ
                        <br>
                        ขนาดไฟล์ไม่เกิน 1 MB
                    </div>
                    <img class="pointer" [src]="viewImage" width="100%" *ngIf="viewImage && addStatus">
                    <img class="pointer" [src]="viewImage" width="100%" *ngIf="viewImage  && updateStatus">
                    <img class="pointer" [src]="formGift.value['Image']" width="100%"
                        *ngIf="!viewImage && formGift.value['Image'] && updateStatus">
                </app-upload-file>
            </div>
            <div class="col-12">
                <p>ชือบัตรกำนัล</p>
                <input type="text" class="form-control" formControlName="Name">
            </div>
            <div class="col-12">
                <p>ประเภทบัตรกำนัล</p>
                <select class="form-select" formControlName="Type">
                    <option value="">เลือกประเภท</option>
                    <option value="discount">ส่วนลด</option>
                    <option value="things">สิ่งของ</option>
                </select>
            </div>
            <ng-container *ngIf="formGift.value['Type'] == 'discount'">
                <div class="col-12">
                    <p>ประเภทส่วนลด</p>
                    <select class="form-select" formControlName="DisType">
                        <option value="">เลือกประเภทส่วนลด</option>
                        <option value="amount">ส่วนลดแบบระบุจำนวน</option>
                        <option value="percentage">ส่วนลดแบบ %</option>
                    </select>
                </div>
                <div class="col-12">
                    <p>ส่วนลด</p>
                    <input type="number" class="form-control" formControlName="DisAmount">
                </div>
            </ng-container>
            <div class="col-12" *ngIf="formGift.value['Type'] == 'things'">
                <p>จำนวนที่ได้รับ</p>
                <input type="number" class="form-control" formControlName="Amount">
            </div>
            <br>
        </div>
        <br>
        <div class="row g-3">
            <!-- <div class="col-12">
                <app-checkbox [InputValue]="formGift.value['Expire'] || 0"
                    (updateValue)="expire($event)">วันที่หมดอายุ</app-checkbox>
            </div> -->
            <ng-container *ngIf="formGift.value['Expire'] == 1">
                <div class="col-6">
                    <p>วันที่เริ่ม</p>
                    <div class="calendar-icon-start">
                        <p-calendar styleClass="w-100" formControlName="Expire_start_edit" dateFormat="dd/mm/yy"
                            (onSelect)="updateExpire($event,'start')" [touchUI]="true"></p-calendar>
                        <span class="material-symbols-outlined icon">
                            calendar_today
                        </span>
                    </div>
                </div>
                <div class="col-6">
                    <p>วันที่สิ้นสุด</p>
                    <div class="calendar-icon-start">
                        <p-calendar styleClass="w-100" formControlName="Expire_end_edit" dateFormat="dd/mm/yy"
                            (onSelect)="updateExpire($event,'end')" [touchUI]="true"></p-calendar>
                        <span class="material-symbols-outlined icon">
                            calendar_today
                        </span>
                    </div>
                </div>
            </ng-container>

        </div>
        <br>
        <div class="row">
            <div class="col-12" *ngIf="formGift.value['Type'] !=''">
                <p>เงื่อนไขการใช้</p>
                <input type="text" class="form-control" formControlName="Condition">
            </div>
            <div class="col-12 text-end mt-3">
                <button class="btn btn-primary me-3" *ngIf="addStatus" (click)="createGift()">
                    บันทึก
                </button>
                <button class="btn btn-primary me-3" *ngIf="updateStatus" (click)="updateGift()">
                    บันทึก
                </button>
                <button class="btn btn-cancel" (click)="clearEvent()">
                    ปิด
                </button>
            </div>
        </div>
    </ng-container>
</p-dialog>